import * as p from '@clack/prompts'
import type { BetterstartCommandRuntime, Cancellable } from '@cli-types/core-engine/commands.js'
import { ALL_FLAG, CANCELLED } from '@cli-constants/commands.js'

export async function promptComponents(
  runtime: BetterstartCommandRuntime,
  cwd: string
): Promise<Cancellable<string[]>> {
  const scope = await p.select({
    message: 'What do you want to update?',
    options: [
      { value: ALL_FLAG, label: 'All components', hint: 'every installed component' },
      { value: 'pick', label: 'Choose components' }
    ]
  })
  if (p.isCancel(scope)) {
    return CANCELLED
  }
  if (scope === ALL_FLAG) {
    return [ALL_FLAG]
  }

  const components = await runtime.listComponentChoices(cwd)
  if (components.length === 0) {
    p.log.warn('No components available to update.')
    return CANCELLED
  }

  const selected = await p.multiselect({
    message: 'Components to update',
    options: components.map((value) => ({ value, label: value }))
  })
  return p.isCancel(selected) ? CANCELLED : selected
}
